// oxlint-disable-next-line cf-web/banned-imports
import { SpinnerIcon } from 'primitives/icons'
import { Button } from '@repo/studio-design-system-ui-button'
import { m } from 'framer-motion'
import * as React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import type { FallbackProps } from 'react-error-boundary'

export function ComponentBoundary({
  children,
  fallbackError,
  fallbackLoading,
}: {
  children?: React.ReactNode
  fallbackError?: ((args: FallbackProps) => React.ReactNode) | null
  fallbackLoading?: React.ReactNode
}) {
  return (
    <ErrorBoundary
      FallbackComponent={
        // we want ppl to allow to pass in `null` as a fallbackError, so undefined will fallback to the default one
        fallbackError === null ? () => null : fallbackError || ErrorBoundaryComponent
      }
    >
      <React.Suspense
        fallback={fallbackLoading === undefined ? <LoadingComponent /> : fallbackLoading}
      >
        {children}
      </React.Suspense>
    </ErrorBoundary>
  )
}

function LoadingComponent() {
  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1, duration: 0.25 }}
      className="flex h-full w-full flex-col items-center justify-center gap-2"
    >
      <span className="sr-only">Loading</span>
      <SpinnerIcon className="h-[24px] w-[24px] animate-spin text-gray-700" />
    </m.div>
  )
}

function ErrorBoundaryComponent({ resetErrorBoundary }: { resetErrorBoundary?(): void }) {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center p-3">
      <p className="mb-3 w-full max-w-[420px] text-balance text-center text-gray-50">
        Oops, something went wrong here. Please refresh the page or get in touch if this happens
        again.
      </p>
      {resetErrorBoundary ? (
        <Button variant="primary" onClick={resetErrorBoundary}>
          Retry
        </Button>
      ) : null}
    </div>
  )
}
